import axios from 'axios'
import config from './config'
import router from '@/router.js'
import notificationState from './store/modules/notification/state';

const baseURL = config.API_HOST;

const axiosInstance = axios.create({
    baseURL: config.API_HOST,
    params: {}
});

axiosInstance.interceptors.request.use(function(request) {
    const token = localStorage.getItem('token');

    request.headers.Accept = "application/json"
    request.headers.Authorization = `Bearer ${token}`
    request.headers['Access-Control-Allow-Origin'] = "*"
    
    return request;
}, function(err) {
    return Promise.reject(err);
});

axiosInstance.interceptors.response.use((response) => {
    return Promise.resolve(response);
}, (error) => {
    if (error.response !== undefined && error.response.status === 503) {
        notificationState.maintenance = true;
    }

    return Promise.reject(error);
});

axiosInstance.interceptors.response.use((response) => {
    return Promise.resolve(response);
}, function(error) {
    if(error.response != undefined && error.response.status == 401) {
        localStorage.clear();
        // Fixed by Paul: ??????????????????
        // router.push('/login');

        if (location.pathname !== '/forgot/password') {
            return Promise.reject(error);
        }

        if (location.pathname !== '/login') {
            return Promise.reject(error);
        }

        if (location.pathname !== '/register') {
            return Promise.reject(error);
        }

        if (location.pathname.startsWith('/reset_password_form/')) {
            return Promise.reject(error);
        }

        if (location.pathname !== '/specialist/login') {
            return Promise.reject(error);
        }

        if (location.pathname.startsWith('/wizard/')) {
            return Promise.reject(error);
        }

        router.push('/login');
    }

    return Promise.reject(error);
});

export default axiosInstance;
